import {isFunction} from 'lodash';
import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[wizard-next]'
})
export class WizardNext {

    private nextLoader: Function;

    public setupNextLoader(loader: Function) {
        this.nextLoader = loader;
    }

    @HostListener('click') onClick() {
        if (isFunction(this.nextLoader)) {
            this.nextLoader();
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.next.ts